import React from 'react';
import { ContentfulPromoCard } from '@jbhi-fi/apis/src/contentful/types';
import { PromoCardProps } from '../../PromoCard/PromoCard';
import { ContentfulImage } from '../../ContentfulImage/ContentfulImage';
import { AssetTransformer } from './AssetTransformer';
import { ContentBlockProps } from '../../ContentBlock';
import { YouTubeTransformer } from './YouTubeTransformer';
import { TermsAndConditionsTransformer } from './TermsAndConditionsTransformer';

export abstract class PromoCardTransformer {
  static toHidden = (entry?: ContentfulPromoCard, isLoggedIn?: boolean) => {
    const loginState = entry?.fields?.loginState;
    if (!loginState) return false;
    if (isLoggedIn) {
      if (loginState === 'Logged in only') return false;
      else return true;
    } else {
      if (loginState === 'Guest only') return false;
      else return true;
    }
  };
  static toContentBlockProps = (
    entry?: ContentfulPromoCard,
    { isLoggedIn }: { isLoggedIn?: boolean } = {}
  ): Partial<ContentBlockProps> | undefined => {
    const isHidden = this.toHidden(entry, isLoggedIn);
    if (isHidden)
      return {
        paddingX: 0,
        paddingY: 0,
      };
    else return;
  };

  static toPromoCardProps = (
    entry?: ContentfulPromoCard,
    { isLoggedIn }: { isLoggedIn?: boolean } = {}
  ): PromoCardProps => {
    return {
      isHidden: this.toHidden(entry, isLoggedIn),
      href: entry?.fields?.url ?? '',
      isContained: true,
      trackingLabel: entry?.fields?.name,
      isDraft: !entry?.fields?.youTube && !(entry?.fields?.mobileImage && entry?.fields?.url),
      image: entry?.fields?.mobileImage ? (
        <ContentfulImage
          {...(AssetTransformer.toContentfulImageProps(entry?.fields?.mobileImage) ?? {})}
          sizes="250px"
        />
      ) : undefined,
      youTubeProps: entry?.fields?.youTube?.fields
        ? YouTubeTransformer.toYouTubePlayerProps(entry.fields.youTube)
        : undefined,
      cardFooter:
        entry?.fields?.subText && entry?.fields?.buttonLabel
          ? {
              subText: entry.fields.subText,
              buttonLabel: entry.fields.buttonLabel,
              brandLogo: entry.fields.brandLogo ?? undefined,
            }
          : undefined,
      trackingData: {
        id: entry?.fields?.name ?? '',
        isBranded: entry?.fields?.isExternal ?? false,
      },
      termsAndConditions: TermsAndConditionsTransformer.toTermsAndConditions(entry?.fields?.termsConditions),
    };
  };
}
